import React, { useState, useEffect } from 'react';
import {AutoridadeAPI} from "../../../../shared/http-requests";
import {Col, Container, Input, Row} from "reactstrap";
import DadosAutoridadeMarc from "../../pages/home/DadosAutoridadeMarc";
import {SpinnerConstructor} from "../../../../shared/components";
import {connect, useDispatch} from "react-redux";
import DadosAutoridadeDetalhes from "../../pages/home/DadosAutoridadeDetalhes";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {clearSubmenuSelected} from "../../../../store/ducks/dadosAcervo";

const Detalhes = ({ closeModal, autoridades }) => {
    const { t } = useTranslation();

    const [dados, setDados] = useState(false);
    const [loading, setLoading] = useState(true);
    const [selectedView, setSelectedView] = useState('def')
    const dispatch = useDispatch();

    useEffect(() => {
        setLoading(true)
        AutoridadeAPI.buscarDetalhesAutoridadeCombo(autoridades).then((response) => {
            const { data } = response;
            setDados(data);
            setLoading(false)
        }).catch(e => console.log(e))
    }, [autoridades]);

    const getContent = () => {
       return  !!dados.length && dados.map((item, index) => {
            if(item.detalhes.length == 0)
                return <></>;
            const descricaoCampo = item.detalhes[0].campos[0].descricao[0];
            return (
                <div key={index}>
                    <label className="s14 preto60 negrito">{descricaoCampo}</label>
                    {
                        selectedView === 'marc' &&
                        (<DadosAutoridadeMarc dados={item.marc} />) || (<DadosAutoridadeDetalhes dados={item.detalhes}/>)
                    }
                </div>
            )
        });
    }

    if (loading) {
        return (<Container>
            <Row>
                <Col
                    xs="12"
                    md={{size: 4, offset: 4}}
                    className="mt-5 p-md-5 p-0"
                >
                    <div className="p-5 text-center animated fadeIn">
                        <SpinnerConstructor
                            visible
                            showLabel
                            height={80}
                            width={80}
                            className="apergamum"
                        />
                    </div>
                </Col>
            </Row>
        </Container>)
    }

    return (
        <Col md="12" xs="12">
            <Row className="pt-3 pb-3 w-100">
                <Col md="12" xs="12">
                    <Row className="b-solid-bottom b-w2 b-tema50 animated fadeIn d-flex justify-content-between">
                        <Col md="5" xs="12" className="cortxt negrito s13">
                            <a className="m-0 link click" onClick={(e) => {
                                dispatch(clearSubmenuSelected())
                            }} >
                                <FontAwesomeIcon icon="arrow-left" className="mr-2" />
                                {t('Voltar')}
                            </a>
                        </Col>
                        <Col
                            md={4}
                            xs="12"
                            className="pb-2 pl-4 pr-4"
                        >
                            <Input
                                type="select"
                                className="b-tema20 preto70 s14"
                                value={selectedView}
                                onChange={e =>
                                    setSelectedView(e.target.value)
                                }
                            >
                                <option value="def">{`${t(
                                    'Exibicao',
                                )} -  ${t('Padrao')}`}</option>
                                <option value="marc">{`${t(
                                    'Exibicao',
                                )} - MARC`}</option>
                            </Input>
                        </Col>
                    </Row>
                </Col>
                <Col md={12} xs={12}>
                    {getContent()}
                </Col>
            </Row>
        </Col>

    )

}


const mapStateToProps = state => ({
    autoridades: state.dadosAcervo.autoridades,
});

export default connect(mapStateToProps)(Detalhes);
